export default __webpack_public_path__ + "static/media/BING.ca881013.png";